import { Injectable } from 'angular-ts-decorators';

/**
 * Service that wraps some methods of {@link
 * https://docs.angularjs.org/api/ng/service/$location $location}, and adds
 * workarounds necessary to make sure protractor waits for location change in
 * e2e.
 */
@Injectable('swLocation')
export class SwLocation {
  constructor(
    private $location,
    private $timeout,
  ) {
    'ngInject';
  }

  /**
   * Wraps {@link https://docs.angularjs.org/api/ng/service/$location#url $location.url}.
   * @param {string} url
   * url value, when used as a setter
   * @return {string}
   * url
   */
  url(url?: string): string {
    // hack to notify protractor that something is under way
    this.$timeout(angular.noop, 500);

    return this.$location.url(url);
  }
}
